import Swatch from "./Swatch";

export default function SpecialColorSliderElement({
  count,
  product,
  page,
  setActiveProduct,
  totalProducts,
  showColors,
  setShowColors,
  activeSku,
}) {
  const siteInfo = window.wpProductFilter.siteInfo;
  const plpPageLayout = siteInfo.plpPageLayout;
  const maxProduct = 7;
  // const maxProduct = plpPageLayout !== "normal" ? 1000 : 5;
  const wpProductCategory = window.wpProductCategory;
  const cat =
    product.z_prod_type === "rugs" ? "area_rugs" : product.z_prod_type;
  const rewrite_slug = wpProductCategory.rewrite_slug[cat]
    ? wpProductCategory.rewrite_slug[cat]
    : wpProductCategory.rewrite_slug;
  let url_slug = product.url_key;
  if (rewrite_slug !== "" && rewrite_slug !== undefined) {
    const segments = url_slug.split("/");
    url_slug = "/" + rewrite_slug + "/" + segments[segments.length - 1];
  }
  url_slug += url_slug.endsWith("/") ? "" : "/";

  return (
    <div
      className={`slide color-box1 special_slide_wrap ${showColors} ${
        count >= 5 ? "hideSlide" : ""
      } ${activeSku == product.sku ? "active_swatch" : ""}`}>
      {page === "plp" ? (
        <div className="special_slide">
          {count === 4 && showColors === "showColor" && (
            <span
              onClick={() => setShowColors("hideColor")}
              className="expanded">
              -
            </span>
          )}
          {count === 4 && totalProducts > 5 && showColors === "hideColor" && (
            <span onClick={() => setShowColors("showColor")}>
              +{totalProducts - 5}
            </span>
          )}
          <a
            href={`${window.location.origin}${url_slug}`}
            onMouseOver={
              plpPageLayout !== "normal"
                ? () => setActiveProduct(product)
                : undefined
            }>
            <Swatch
              swatch={product.swatch}
              pdpUrl={`${window.location.origin}${url_slug}`}
              height={50}
              width={50}
              title={product.color}
            />
          </a>
        </div>
      ) : (
        <a href={`${window.location.origin}${url_slug}`}>
          <Swatch
            swatch={product.swatch}
            pdpUrl={`${window.location.origin}${url_slug}`}
            height={100}
            width={100}
          />
        </a>
      )}
    </div>
  );
}
